import { z } from "zod";

export const maintenanceOverviewSchema = z.object({
  checkedAt: z.string().datetime(),
  storage: z.enum(["memory", "postgres"]),
  counts: z.object({
    users: z.number().int().nonnegative(),
    issues: z.number().int().nonnegative(),
    agents: z.number().int().nonnegative(),
  }),
  queue: z.object({
    pending: z.number().int().nonnegative(),
    processing: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    oldestPendingAt: z.string().datetime().nullable(),
  }),
});
export type MaintenanceOverview = z.infer<typeof maintenanceOverviewSchema>;

export const demoCleanupReasonSchema = z.enum([
  "unchanged_demo",
  "modified_demo",
  "real_data",
  "current_admin",
  "referenced",
  "mixed_issue",
]);

export const demoCleanupRecordSchema = z.object({
  collection: z.string(),
  id: z.string(),
  label: z.string(),
  action: z.enum(["delete", "keep"]),
  reason: demoCleanupReasonSchema,
});

export const demoCleanupPreviewSchema = z.object({
  previewToken: z.string(),
  expiresAt: z.string().datetime(),
  deleteCount: z.number().int().nonnegative(),
  keepCount: z.number().int().nonnegative(),
  records: z.array(demoCleanupRecordSchema),
});

export const demoCleanupRequestSchema = z
  .object({
    previewToken: z
      .string()
      .max(256)
      .regex(/^\d+\.[a-f0-9]{64}$/),
    confirmation: z.literal("DELETE DEMO"),
    backupConfirmed: z.literal(true),
  })
  .strict();

export const demoCleanupResultSchema = z.object({ deletedCount: z.number().int().nonnegative() });
export type DemoCleanupRecord = z.infer<typeof demoCleanupRecordSchema>;
export type DemoCleanupPreview = z.infer<typeof demoCleanupPreviewSchema>;
export type DemoCleanupRequest = z.infer<typeof demoCleanupRequestSchema>;
